import { msalClient } from './msalClient';

export interface AuthClient {
  ready(): Promise<void>;
  handleRedirect(): Promise<void>;
  hasAccount(): boolean;
  login(): Promise<void>;
  logout(): Promise<void>;
  acquireToken(): Promise<string>;
}

const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

// ponytail: devClient (jose + clé RSA dev) chargé en import dynamique — il reste
// hors du bundle prod. Avec VITE_USE_EMULATORS=false (constante au build), la
// branche import('../dev/devToken') est morte et tree-shakée par Rollup.
// Contrat: ready() est toujours appelé (et awaité) avant hasAccount() — cf.
// AuthProvider — donc `impl` est résolu au moment où hasAccount() est lu.
let impl: AuthClient | null = null;
async function resolve(): Promise<AuthClient> {
  if (!impl) impl = useEmulators ? (await import('../dev/devToken')).devClient : msalClient;
  return impl;
}

export const authClient: AuthClient = {
  async ready() {
    await (await resolve()).ready();
  },
  async handleRedirect() {
    await (await resolve()).handleRedirect();
  },
  hasAccount() {
    return impl?.hasAccount() ?? false; // résolu par ready() en amont
  },
  async login() {
    await (await resolve()).login();
  },
  async logout() {
    await (await resolve()).logout();
  },
  async acquireToken() {
    return (await resolve()).acquireToken();
  },
};
export { useEmulators };
